// ─── src/components/dashboard/PublicFieldChip.tsx ────────────────────────────
//
// Small "Public" chip + legend banner, matching the exact visual language
// used on the public /gew "host a meetup" form. The two edit modals
// (EditEventModal, EditProposalModal) reuse these so operators see the
// same signal whether they're on the public site or in the dashboard.

export function PublicChip() {
  return (
    <span
      className="inline-flex items-center gap-1 align-middle mr-1.5 rtl:ml-1.5 rtl:mr-0 px-1.5 py-0.5 rounded-full text-[9px] font-semibold uppercase tracking-normal bg-emerald-500/15 text-emerald-300 border border-emerald-500/30"
      title="سيظهر هذا الحقل على صفحة الفعالية العامة"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
      عام
    </span>
  );
}

/**
 * Top-of-modal callout explaining the chip. Mirrors the mainwebsite's
 * proposal form so operators reading either surface see the same rule.
 *
 * `everythingPublic` variant (used on EditEventModal, where all fields
 * are public) skips the "silence = internal" clause since it doesn't
 * apply.
 */
export function PublicFieldsLegend({
  everythingPublic = false,
}: { everythingPublic?: boolean }) {
  return (
    <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/5 p-3">
      <p className="text-sm text-gray-200 leading-relaxed flex items-start gap-2">
        <PublicChip />
        <span>
          {everythingPublic ? (
            <>الحقول في هذا النموذج <strong className="text-emerald-300">تظهر جميعها</strong> على صفحة الفعالية العامة بعد الحفظ.</>
          ) : (
            <>الحقول الموسومة بـ <strong className="text-emerald-300">«عام»</strong> ستظهر على صفحة الفعالية العامة. باقي الحقول تبقى خاصة بفريق العمليات فقط.</>
          )}
        </span>
      </p>
    </div>
  );
}
